import Http from '@/utils/http'
import { RequestType } from '@/typings/enum/Common'
import NLoginApi = global.NLoginApi

class VersionRelease extends Http {
  [x: string]: any
  public async listVersions(params: NLoginApi.ListVersionsRequestData) {
    return await super.request<NLoginApi.ListVersionsData>({
      url: '/crossbowSystem/listVersions',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data: params
    })
  }

  public async insertVersion(params: NLoginApi.InsertVersionRequestData) {
    return await super.request<NLoginApi.ApiResponse>({
      url: '/crossbowSystem/insertVersion',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data: params
    })
  }

  public async updateVersion(params: NLoginApi.UpdateVersionRequestData) {
    return await super.request<NLoginApi.ApiResponse>({
      url: '/crossbowSystem/updateVersion',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data: params
    })
  }

  public async deleteVersion(params: NLoginApi.DeleteVersionRequestData) {
    return await super.request<NLoginApi.ApiResponse>({
      url: '/crossbowSystem/deleteVersion',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data: params
    })
  }
}

export default VersionRelease
